import React from 'react';
import { withTheme } from 'styled-components';
import { Helmet } from 'react-helmet-async';

const RouteWrapper = ({ theme, title = '', children }) => {
  return <>
    <Helmet>
      <link rel="shortcut icon" href={theme.brand.favicon} />
      <title>{title}</title>
    </Helmet>
    {children}
  </>
};

export default withTheme(RouteWrapper);
